import { TmsBusinessTypeEnum } from 'enums/TmsEnum';

// 星期选项 - 改为函数以支持国际化
export const getWeekdaysOptions = (t: (key: string) => string) => [
    {value: 1, label: t('enum.weekdaysOptions.monday')},
    {value: 2, label: t('enum.weekdaysOptions.tuesday')},
    {value: 3, label: t('enum.weekdaysOptions.wednesday')},
    {value: 4, label: t('enum.weekdaysOptions.thursday')},
    {value: 5, label: t('enum.weekdaysOptions.friday')},
    {value: 6, label: t('enum.weekdaysOptions.saturday')},
    {value: 7, label: t('enum.weekdaysOptions.sunday')}
];

/** 路线业务类型展示（与路线 businessType / TmsBusinessTypeEnum 一致） */
export const getTmsRouteBusinessTypeLabel = (
    t: (key: string) => string,
    businessType: number | null | undefined
): string => {
    if (businessType == null) {
        return '';
    }
    switch (businessType) {
        case TmsBusinessTypeEnum.OwnRoute:
            return t('tms.task.businessTypes.ownRoute');
        case TmsBusinessTypeEnum.TikTok:
            return t('tms.task.businessTypes.tiktok');
        case TmsBusinessTypeEnum.TemuGA:
            return t('tms.task.businessTypes.temuGA');
        case TmsBusinessTypeEnum.TemuSCF:
            return t('tms.task.businessTypes.temuSCF');
        default:
            return String(businessType);
    }
};
